import { useState, useEffect } from "react"
import { authFetch } from "../../utils/api"

const API = process.env.REACT_APP_API_URL

const TIPOS_PLAZO    = ["MENSUAL", "BIMESTRAL", "TRIMESTRAL", "CUATRIMESTRAL", "SEMESTRAL", "OTRO"]
const ESTADOS_ENTREGA = ["PENDIENTE", "DISTRIBUCION", "ENTREGADO", "CANCELADO"]

const ESTADO_CONFIG = {
  DISTRIBUCION: { label: "en distribución", icon: "fa-truck",         className: "status-distribucion" },
  PENDIENTE:    { label: "pendiente",        icon: "fa-spinner",       className: "status-pendiente"    },
  ENTREGADO:    { label: "entregado",        icon: "fa-check-double",  className: "status-entregado"    },
  CANCELADO:    { label: "cancelado",        icon: "fa-ban",           className: "status-cancelado"    },
}

const FORM_OC_VACIO      = { nroOrdenCompra: "", fEmision: "", fVencimiento: "", tipoPlazo: "", nroEntregas: "" }
const FORM_ENTREGA_VACIO = { estado: "", fEntrega: "", observaciones: "", nroFactura: "", nroNotaCredito: "", nroRemito: "" }
const POR_PAGINA = 6

function toInputDate(iso) {
  if (!iso) return ""
  return iso.slice(0, 10)
}

function formatDate(iso) {
  if (!iso) return "—"
  return new Date(iso).toLocaleDateString("es-AR", { timeZone: "UTC" })
}

function GestionOC() {
  const [pacientes, setPacientes]             = useState([])
  const [cargando, setCargando]               = useState(true)
  const [busqueda, setBusqueda]               = useState("")
  const [mostrarBaja, setMostrarBaja]         = useState(false)
  const [pagina, setPagina]                   = useState(1)

  const [expandidoId, setExpandidoId]         = useState(null)
  const [ordenesCache, setOrdenesCache]       = useState({})
  const [cargandoOrdenes, setCargandoOrdenes] = useState({})

  const [agregandoId, setAgregandoId]         = useState(null)
  const [formOC, setFormOC]                   = useState(FORM_OC_VACIO)
  const [mensajeOC, setMensajeOC]             = useState(null)

  const [editandoOCId, setEditandoOCId]       = useState(null)
  const [formEditarOC, setFormEditarOC]       = useState(FORM_OC_VACIO)
  const [mensajeEditarOC, setMensajeEditarOC] = useState(null)

  const [editandoId, setEditandoId]           = useState(null)
  const [formEntrega, setFormEntrega]         = useState(FORM_ENTREGA_VACIO)
  const [adjunto, setAdjunto]                 = useState(null)
  const [mensajeEntrega, setMensajeEntrega]   = useState(null)

  useEffect(() => {
    authFetch(`${API}/pacientes`)
      .then(r => r.json())
      .then(setPacientes)
      .finally(() => setCargando(false))
  }, [])

  const fetchOrdenes = async (pacienteId, force = false) => {
    if (!force && ordenesCache[pacienteId]) return
    setCargandoOrdenes(prev => ({ ...prev, [pacienteId]: true }))
    try {
      const res = await authFetch(`${API}/ordenes?pacienteId=${pacienteId}`)
      const data = await res.json()
      setOrdenesCache(prev => ({ ...prev, [pacienteId]: data }))
    } finally {
      setCargandoOrdenes(prev => ({ ...prev, [pacienteId]: false }))
    }
  }

  const handleToggleExpand = async (pacienteId) => {
    if (expandidoId === pacienteId) {
      setExpandidoId(null)
      setAgregandoId(null)
      setEditandoId(null)
    } else {
      setExpandidoId(pacienteId)
      setAgregandoId(null)
      setEditandoId(null)
      setMensajeOC(null)
      setMensajeEntrega(null)
      await fetchOrdenes(pacienteId)
    }
  }

  const handleCargarOC = async (pacienteId) => {
    setMensajeOC(null)
    try {
      const res = await authFetch(`${API}/ordenes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formOC, pacienteId, nroEntregas: Number(formOC.nroEntregas) }),
      })
      if (!res.ok) {
        const err = await res.json()
        setMensajeOC({ tipo: "error", texto: err.error || "Error al cargar OC" })
        return
      }
      setMensajeOC({ tipo: "ok", texto: "Orden cargada correctamente" })
      setFormOC(FORM_OC_VACIO)
      setAgregandoId(null)
      setOrdenesCache(prev => ({ ...prev, [pacienteId]: null }))
      await fetchOrdenes(pacienteId, true)
    } catch {
      setMensajeOC({ tipo: "error", texto: "Error de conexión" })
    }
  }

  const handleBorrarOC = async (ordenId, pacienteId) => {
    if (!window.confirm("¿Seguro que querés borrar esta orden de compra y todas sus entregas?")) return
    try {
      const res = await authFetch(`${API}/ordenes/${ordenId}`, { method: "DELETE" })
      if (!res.ok) return
      if (editandoOCId === ordenId) setEditandoOCId(null)
      setOrdenesCache(prev => ({ ...prev, [pacienteId]: null }))
      await fetchOrdenes(pacienteId, true)
    } catch {}
  }

  const handleAbrirEdicionOC = (orden) => {
    if (editandoOCId === orden.id) { setEditandoOCId(null); setMensajeEditarOC(null); return }
    setEditandoOCId(orden.id)
    setFormEditarOC({
      nroOrdenCompra: orden.nroOrdenCompra || "",
      nroPedido:      orden.nroPedido      || "",
      fEmision:       toInputDate(orden.fEmision),
      fVencimiento:   toInputDate(orden.fVencimiento),
      tipoPlazo:      orden.tipoPlazo      || "",
      nroEntregas:    orden.nroEntregas    ?? "",
    })
    setMensajeEditarOC(null)
  }

  const handleGuardarOC = async (ordenId, pacienteId) => {
    setMensajeEditarOC(null)
    try {
      const res = await authFetch(`${API}/ordenes/${ordenId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formEditarOC, nroPedido: undefined, nroEntregas: Number(formEditarOC.nroEntregas) }),
      })
      if (!res.ok) {
        const err = await res.json()
        setMensajeEditarOC({ tipo: "error", texto: err.error || "Error al guardar" })
        return
      }
      setMensajeEditarOC({ tipo: "ok", texto: "Orden actualizada" })
      setOrdenesCache(prev => ({ ...prev, [pacienteId]: null }))
      await fetchOrdenes(pacienteId, true)
      setEditandoOCId(null)
    } catch {
      setMensajeEditarOC({ tipo: "error", texto: "Error de conexión" })
    }
  }

  const handleAbrirEdicion = (entrega) => {
    if (editandoId === entrega.id) { setEditandoId(null); return }
    setEditandoId(entrega.id)
    setFormEntrega({
      estado:         entrega.estado        || "",
      fEntrega:       toInputDate(entrega.fEntrega),
      observaciones:  entrega.observaciones || "",
      nroFactura:     entrega.nroFactura    || "",
      nroNotaCredito: entrega.nroNotaCredito || "",
      nroRemito:      entrega.nroRemito     || "",
    })
    setAdjunto(null)
    setMensajeEntrega(null)
  }

  const handleGuardarEntrega = async (entrega, pacienteId) => {
    setMensajeEntrega(null)
    try {
      const fd = new FormData()
      fd.append("estado", formEntrega.estado)
      if (formEntrega.fEntrega)       fd.append("fEntrega",       formEntrega.fEntrega)
      if (formEntrega.observaciones)  fd.append("observaciones",  formEntrega.observaciones)
      fd.append("nroFactura",     formEntrega.nroFactura     || "")
      fd.append("nroNotaCredito", formEntrega.nroNotaCredito || "")
      fd.append("nroRemito",      formEntrega.nroRemito      || "")
      if (adjunto) fd.append("adjunto", adjunto)

      const res = await authFetch(`${API}/entregas/${entrega.id}`, { method: "PUT", body: fd })
      if (!res.ok) { setMensajeEntrega({ tipo: "error", texto: "Error al guardar" }); return }

      const actualizada = await res.json()
      setOrdenesCache(prev => ({
        ...prev,
        [pacienteId]: prev[pacienteId]?.map(o => ({
          ...o,
          entregas: o.entregas.map(e => e.id === actualizada.id ? actualizada : e),
        })),
      }))
      setEditandoId(null)
      setAdjunto(null)
    } catch {
      setMensajeEntrega({ tipo: "error", texto: "Error de conexión" })
    }
  }

  const handleSwapEntregas = async (orden, pacienteId, idx, direction) => {
    const targetIdx = direction === "up" ? idx - 1 : idx + 1
    if (targetIdx < 0 || targetIdx >= orden.entregas.length) return
    try {
      const res = await authFetch(`${API}/entregas/swap`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id1: orden.entregas[idx].id, id2: orden.entregas[targetIdx].id }),
      })
      if (!res.ok) return
      setOrdenesCache(prev => ({ ...prev, [pacienteId]: null }))
      await fetchOrdenes(pacienteId, true)
    } catch {}
  }

  const handleAgregarEntrega = async (ordenCompraId, pacienteId) => {
    try {
      const res = await authFetch(`${API}/entregas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ordenCompraId }),
      })
      if (!res.ok) return
      setOrdenesCache(prev => ({ ...prev, [pacienteId]: null }))
      await fetchOrdenes(pacienteId, true)
    } catch {}
  }

  const handleBorrarEntrega = async (entregaId, pacienteId) => {
    if (!window.confirm("¿Seguro que querés borrar esta entrega?")) return
    try {
      const res = await authFetch(`${API}/entregas/${entregaId}`, { method: "DELETE" })
      if (!res.ok) return
      if (editandoId === entregaId) setEditandoId(null)
      setOrdenesCache(prev => ({ ...prev, [pacienteId]: null }))
      await fetchOrdenes(pacienteId, true)
    } catch {}
  }

  const handleBorrarAdjunto = async (entrega, pacienteId) => {
    if (adjunto) { setAdjunto(null); return }
    setMensajeEntrega(null)
    try {
      const res = await authFetch(`${API}/entregas/${entrega.id}/adjunto`, { method: "DELETE" })
      if (!res.ok) { setMensajeEntrega({ tipo: "error", texto: "Error al borrar adjunto" }); return }
      setOrdenesCache(prev => ({
        ...prev,
        [pacienteId]: prev[pacienteId]?.map(o => ({
          ...o,
          entregas: o.entregas.map(e => e.id === entrega.id ? { ...e, adjuntoUrl: null, adjuntoNombre: null } : e),
        })),
      }))
    } catch {
      setMensajeEntrega({ tipo: "error", texto: "Error al borrar adjunto" })
    }
  }

  const q = busqueda.toLowerCase().trim()
  const pacientesFiltrados = pacientes.filter(p => {
    if (!mostrarBaja && p.pacienteEstado === "BAJA") return false
    return !q ||
      p.apellido?.toLowerCase().includes(q) ||
      p.nombre?.toLowerCase().includes(q) ||
      p.nroSocio?.toLowerCase().includes(q) ||
      p.dni?.toLowerCase().includes(q)
  })
  const totalPaginas  = Math.ceil(pacientesFiltrados.length / POR_PAGINA)
  const paginaActual  = Math.min(pagina, totalPaginas || 1)
  const pacientesPagina = pacientesFiltrados.slice((paginaActual - 1) * POR_PAGINA, paginaActual * POR_PAGINA)

  return (
    <div className="adminPanel column">

      <div className="adminPanelTitle row">
        <i className="fa-solid fa-file-circle-plus"></i>
        GESTIÓN DE ÓRDENES DE COMPRA
      </div>

      {cargando && <div className="adminEmptyState">cargando...</div>}

      {!cargando && (
        <div className="adminPreviewBox">
          <div className="adminBusquedaRow">
            <input
              type="text"
              placeholder="buscar por nombre, n° socio o DNI..."
              value={busqueda}
              onChange={e => { setBusqueda(e.target.value); setExpandidoId(null); setPagina(1) }}
            />
            <label className="adminCheckboxLabel">
              <input type="checkbox" checked={mostrarBaja} onChange={e => { setMostrarBaja(e.target.checked); setPagina(1) }} />
              mostrar dados de baja
            </label>
            {busqueda && (
              <span className="adminBusquedaInfo">
                {pacientesFiltrados.length} de {pacientes.length} pacientes
              </span>
            )}
          </div>

          <table className="adminPreviewTable">
            <thead>
              <tr>
                <th></th>
                <th>apellido</th>
                <th>nombre</th>
                <th>obra social</th>
                <th>n° socio</th>
                <th>DNI</th>
                <th>estado</th>
              </tr>
            </thead>
            <tbody>
              {pacientesPagina.length === 0 ? (
                <tr><td colSpan={7}><div className="adminEmptyState">sin resultados</div></td></tr>
              ) : pacientesPagina.map(p => {
                const expandido      = expandidoId === p.id
                const ordenes        = ordenesCache[p.id] || []
                const cargandoOrd   = cargandoOrdenes[p.id]

                return (
                  <>
                    <tr
                      key={p.id}
                      className={`adminRowClickable${expandido ? " usuarioRowActiva" : ""}`}
                      onClick={() => handleToggleExpand(p.id)}
                    >
                      <td>
                        <div className="adminExpandCell">
                          <i className={`fa-solid fa-chevron-${expandido ? "down" : "right"} adminExpandChevron`} />
                          <button
                            className={`usuarioEditBtn${agregandoId === p.id ? " usuarioEditBtn--active" : ""}`}
                            title="agregar orden de compra"
                            onClick={e => {
                              e.stopPropagation()
                              if (agregandoId === p.id) { setAgregandoId(null); setFormOC(FORM_OC_VACIO); setMensajeOC(null); return }
                              setAgregandoId(p.id)
                              setFormOC(FORM_OC_VACIO)
                              setMensajeOC(null)
                              if (expandidoId !== p.id) {
                                setExpandidoId(p.id)
                                fetchOrdenes(p.id)
                              }
                            }}
                          >
                            <i className={`fa-solid fa-${agregandoId === p.id ? "xmark" : "plus"}${agregandoId !== p.id ? " adminIconGreen" : ""}`} />
                          </button>
                        </div>
                      </td>
                      <td>{p.apellido}</td>
                      <td>{p.nombre}</td>
                      <td>{p.prestador || <span className="adminPlaceholder">—</span>}</td>
                      <td>{p.nroSocio  || <span className="adminPlaceholder">—</span>}</td>
                      <td>{p.dni       || <span className="adminPlaceholder">—</span>}</td>
                      <td>
                        <span className={`usuarioRolBadge pacienteEstadoBadge--${p.pacienteEstado?.toLowerCase()}`}>
                          {p.pacienteEstado === "ACTIVO" ? "activo" : p.pacienteEstado === "INACTIVO" ? "inactivo" : "baja"}
                        </span>
                      </td>
                    </tr>

                    {expandido && (
                      <tr key={`${p.id}-exp`} className="usuarioFormRow">
                        <td colSpan={7}>
                          <div className="usuarioFormInline">

                            {agregandoId === p.id && (
                              <div className="adminSection">
                                <div className="adminSectionLabel">nueva orden de compra</div>
                                <div className="adminRow">
                                  <div className="adminField">
                                    <label>n° oc</label>
                                    <input type="text" placeholder="ingresar número" value={formOC.nroOrdenCompra} onChange={e => setFormOC(f => ({ ...f, nroOrdenCompra: e.target.value }))} />
                                  </div>
                                </div>
                                <div className="adminRow">
                                  <div className="adminField">
                                    <label>fecha emisión</label>
                                    <input type="date" value={formOC.fEmision} onChange={e => setFormOC(f => ({ ...f, fEmision: e.target.value }))} />
                                  </div>
                                  <div className="adminField">
                                    <label>fecha vencimiento</label>
                                    <input type="date" value={formOC.fVencimiento} onChange={e => setFormOC(f => ({ ...f, fVencimiento: e.target.value }))} />
                                  </div>
                                </div>
                                <div className="adminRow">
                                  <div className="adminField">
                                    <label>tipo de plazo</label>
                                    <select value={formOC.tipoPlazo} onChange={e => setFormOC(f => ({ ...f, tipoPlazo: e.target.value }))}>
                                      <option value="">trimestral, bimestral...</option>
                                      {TIPOS_PLAZO.map(t => <option key={t} value={t}>{t.toLowerCase()}</option>)}
                                    </select>
                                  </div>
                                  <div className="adminField adminField--narrow">
                                    <label>n° entregas</label>
                                    <input type="number" placeholder="n°" value={formOC.nroEntregas} onChange={e => setFormOC(f => ({ ...f, nroEntregas: e.target.value }))} />
                                  </div>
                                </div>
                                {mensajeOC && <div className={`adminMensaje adminMensaje--${mensajeOC.tipo}`}>{mensajeOC.texto}</div>}
                                <div className="adminBtnRow">
                                  <button className="adminBtn adminBtn--primary" onClick={() => handleCargarOC(p.id)}>cargar orden</button>
                                  <button className="adminBtn" onClick={() => { setAgregandoId(null); setFormOC(FORM_OC_VACIO); setMensajeOC(null) }}>cancelar</button>
                                </div>
                              </div>
                            )}

                            {cargandoOrd
                              ? <div className="adminEmptyState">cargando...</div>
                              : ordenes.length === 0
                                ? <div className="adminEmptyState">sin órdenes de compra</div>
                                : (
                                  <div className="adminOCList">
                                    {ordenes.map(orden => (
                                      <div key={orden.id} className="adminOCItem">

                                        <div className="adminOCItemHeader">
                                          <button className="usuarioEditBtn" title="agregar entrega" onClick={() => handleAgregarEntrega(orden.id, p.id)}>
                                            <i className="fa-solid fa-plus adminIconGreen" />
                                          </button>
                                          <span>OC {orden.nroOrdenCompra} — emisión {formatDate(orden.fEmision)}{orden.fVencimiento ? ` — vence ${formatDate(orden.fVencimiento)}` : ""}{orden.tipoPlazo ? ` — ${orden.tipoPlazo.toLowerCase()}` : ""}</span>
                                          <button
                                            className={`usuarioEditBtn${editandoOCId === orden.id ? " usuarioEditBtn--active" : ""}`}
                                            title="editar orden de compra"
                                            onClick={() => handleAbrirEdicionOC(orden)}
                                          >
                                            <i className={`fa-solid fa-${editandoOCId === orden.id ? "xmark" : "pen"}`} />
                                          </button>
                                          <button
                                            className="usuarioEditBtn adminOCEntregaTrash"
                                            title="borrar orden de compra"
                                            onClick={() => handleBorrarOC(orden.id, p.id)}
                                          >
                                            <i className="fa-solid fa-trash adminDanger" />
                                          </button>
                                        </div>

                                        {editandoOCId === orden.id && (
                                          <div className="adminOCEditForm">
                                            <div className="adminRow">
                                              <div className="adminField">
                                                <label>n° oc</label>
                                                <input type="text" value={formEditarOC.nroOrdenCompra} onChange={e => setFormEditarOC(f => ({ ...f, nroOrdenCompra: e.target.value }))} />
                                              </div>
                                              <div className="adminField">
                                                <label>n° pedido</label>
                                                <input type="text" value={formEditarOC.nroPedido} readOnly disabled title="El número de pedido lo asigna el sistema y no se puede modificar" />
                                              </div>
                                            </div>
                                            <div className="adminRow">
                                              <div className="adminField">
                                                <label>fecha emisión</label>
                                                <input type="date" value={formEditarOC.fEmision} onChange={e => setFormEditarOC(f => ({ ...f, fEmision: e.target.value }))} />
                                              </div>
                                              <div className="adminField">
                                                <label>fecha vencimiento</label>
                                                <input type="date" value={formEditarOC.fVencimiento} onChange={e => setFormEditarOC(f => ({ ...f, fVencimiento: e.target.value }))} />
                                              </div>
                                            </div>
                                            <div className="adminRow">
                                              <div className="adminField">
                                                <label>tipo de plazo</label>
                                                <select value={formEditarOC.tipoPlazo} onChange={e => setFormEditarOC(f => ({ ...f, tipoPlazo: e.target.value }))}>
                                                  <option value="">trimestral, bimestral...</option>
                                                  {TIPOS_PLAZO.map(t => <option key={t} value={t}>{t.toLowerCase()}</option>)}
                                                </select>
                                              </div>
                                              <div className="adminField adminField--narrow">
                                                <label>n° entregas</label>
                                                <input type="number" min={orden.entregas.length} value={formEditarOC.nroEntregas} onChange={e => setFormEditarOC(f => ({ ...f, nroEntregas: e.target.value }))} />
                                              </div>
                                            </div>
                                            {mensajeEditarOC && (
                                              <div className={`adminMensaje adminMensaje--${mensajeEditarOC.tipo}`}>{mensajeEditarOC.texto}</div>
                                            )}
                                            <div className="adminBtnRow">
                                              <button className="adminBtn adminBtn--primary" onClick={() => handleGuardarOC(orden.id, p.id)}>guardar cambios</button>
                                              <button className="adminBtn" onClick={() => { setEditandoOCId(null); setMensajeEditarOC(null) }}>cancelar</button>
                                            </div>
                                          </div>
                                        )}

                                        <div className="adminOCEntregas">
                                          {orden.entregas.map((entrega, idx) => {
                                            const cfg     = ESTADO_CONFIG[entrega.estado] || { label: entrega.estado, icon: "fa-circle-question", className: "" }
                                            const editando = editandoId === entrega.id
                                            const isFirst  = idx === 0
                                            const isLast   = idx === orden.entregas.length - 1

                                            return (
                                              <div key={entrega.id}>
                                                <div className="adminOCEntregaRow">
                                                  <div className="adminReorderBtns">
                                                    <button className="adminReorderBtn" onClick={() => handleSwapEntregas(orden, p.id, idx, "up")} disabled={isFirst}>▲</button>
                                                    <button className="adminReorderBtn" onClick={() => handleSwapEntregas(orden, p.id, idx, "down")} disabled={isLast}>▼</button>
                                                  </div>
                                                  <span>entrega {entrega.nroEntrega}</span>
                                                  <span className={`estado ${cfg.className} adminEstadoBadgeRow`}>
                                                    <i className={`fa-solid ${cfg.icon}`} />{cfg.label}
                                                  </span>
                                                  <span>{formatDate(entrega.fEntrega)}</span>
                                                  {entrega.adjuntoUrl && (
                                                    <a href={`${API}${entrega.adjuntoUrl}`} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>
                                                      <i className="fa-solid fa-file-pdf adminIconBlue" />
                                                    </a>
                                                  )}
                                                  <button
                                                    className={`usuarioEditBtn${editando ? " usuarioEditBtn--active" : ""}`}
                                                    onClick={() => handleAbrirEdicion(entrega)}
                                                    title="editar entrega"
                                                  >
                                                    <i className={`fa-solid fa-${editando ? "xmark" : "pencil"}`} />
                                                  </button>
                                                  <button
                                                    className="usuarioEditBtn adminOCEntregaTrash"
                                                    onClick={() => handleBorrarEntrega(entrega.id, p.id)}
                                                    title="borrar entrega"
                                                  >
                                                    <i className="fa-solid fa-trash adminDanger" />
                                                  </button>
                                                </div>

                                                {editando && (
                                                  <div className="adminOCEntregaForm">
                                                    <div className="adminRow">
                                                      <div className="adminField">
                                                        <label>estado</label>
                                                        <select value={formEntrega.estado} onChange={e => setFormEntrega(f => ({ ...f, estado: e.target.value }))}>
                                                          <option value="">seleccionar</option>
                                                          {ESTADOS_ENTREGA.map(e => <option key={e} value={e}>{e.toLowerCase()}</option>)}
                                                        </select>
                                                      </div>
                                                      <div className="adminField">
                                                        <label>fecha entrega</label>
                                                        <input type="date" value={formEntrega.fEntrega} onChange={e => setFormEntrega(f => ({ ...f, fEntrega: e.target.value }))} />
                                                      </div>
                                                      <div className="adminField">
                                                        <label>adjunto</label>
                                                        <div className="adminAdjuntoRow">
                                                          <label className="adminBtn adminFileLabel">
                                                            subir .pdf
                                                            <input type="file" accept="application/pdf" className="adminHidden" onChange={e => setAdjunto(e.target.files[0] || null)} />
                                                          </label>
                                                          {(adjunto || entrega.adjuntoUrl) && (
                                                            <>
                                                              <span className="adminSuccessText">
                                                                {adjunto ? adjunto.name : (entrega.adjuntoNombre || entrega.adjuntoUrl?.split("/").pop())}
                                                              </span>
                                                              <button className="adminBtn adminBtn--danger" onClick={() => handleBorrarAdjunto(entrega, p.id)}>borrar</button>
                                                            </>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="adminRow">
                                                      <div className="adminField">
                                                        <label>n° factura</label>
                                                        <input type="text" value={formEntrega.nroFactura} onChange={e => setFormEntrega(f => ({ ...f, nroFactura: e.target.value }))} />
                                                      </div>
                                                      <div className="adminField">
                                                        <label>n° nota de crédito</label>
                                                        <input type="text" value={formEntrega.nroNotaCredito} onChange={e => setFormEntrega(f => ({ ...f, nroNotaCredito: e.target.value }))} />
                                                      </div>
                                                      <div className="adminField">
                                                        <label>n° remito</label>
                                                        <input type="text" value={formEntrega.nroRemito} onChange={e => setFormEntrega(f => ({ ...f, nroRemito: e.target.value }))} />
                                                      </div>
                                                    </div>
                                                    <div className="adminRowFull">
                                                      <label>observaciones</label>
                                                      <textarea value={formEntrega.observaciones} onChange={e => setFormEntrega(f => ({ ...f, observaciones: e.target.value }))} />
                                                    </div>
                                                    {mensajeEntrega && (
                                                      <div className={`adminMensaje adminMensaje--${mensajeEntrega.tipo}`}>{mensajeEntrega.texto}</div>
                                                    )}
                                                    <div className="adminBtnRow">
                                                      <button className="adminBtn adminBtn--primary" onClick={() => handleGuardarEntrega(entrega, p.id)}>guardar cambios</button>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            )
                                          })}
                                        </div>

                                      </div>
                                    ))}
                                  </div>
                                )
                            }

                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                )
              })}
            </tbody>
          </table>
        </div>
      )}

      {!cargando && totalPaginas > 1 && (
        <div className="adminPaginacion">
          <button className="adminBtn" onClick={() => { setPagina(p => p - 1); setExpandidoId(null) }} disabled={paginaActual === 1}>{"<"}</button>
          <span className="adminPaginacionInfo">{paginaActual} / {totalPaginas}</span>
          <button className="adminBtn" onClick={() => { setPagina(p => p + 1); setExpandidoId(null) }} disabled={paginaActual === totalPaginas}>{">"}</button>
        </div>
      )}

    </div>
  )
}

export default GestionOC
